import React from 'react'

import NavMenuItem from './NavMenuItem'

export default function SmartMenuList(props) {

  const {items, ...p} = props;

  return (
    <ul>
 
      {items.map((item) => {
        return <NavMenuItem {...props}   item={item} key={item.id}/>
      })}
    </ul>
  )
}
